const topics = [
  { label: '#悬疑烧脑', count: '128万讨论', hot: true },
  { label: '#国产剧崛起', count: '96万讨论', hot: true },
  { label: '#暑假追剧', count: '85万讨论', hot: true },
  { label: '#电影推荐', count: '73万讨论', hot: false },
  { label: '#高分韩剧', count: '68万讨论', hot: false },
  { label: '#科幻大片', count: '61万讨论', hot: false },
  { label: '#综艺笑点', count: '55万讨论', hot: false },
  { label: '#港片情怀', count: '47万讨论', hot: false },
  { label: '#纪录片', count: '39万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">TOPICS</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">热门话题</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">全网影迷正在热议的话题，加入讨论发现更多精彩</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
            {topics.map((t, i) => (
              <div
                key={i}
                className={`inline-flex items-center gap-2 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 ${
                  t.hot
                    ? 'bg-accent-500/10 border border-accent-500/25 hover:bg-accent-500/20 text-accent-300'
                    : 'bg-background-200/60 border border-background-200/40 hover:border-primary-500/20 hover:bg-background-300/60 text-foreground-300'
                }`}
              >
                <span className="text-sm font-medium whitespace-nowrap">{t.label}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{t.count}</span>
                {t.hot && <i className="ri-fire-line text-xs text-accent-400"></i>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}